/**
 * Brand colors for JS-side usage (graph and SVG styles, Loader props), as the CSS variables of
 * styles/buttonTokens.css so the brand is defined once. They work wherever a CSS value goes;
 * antd theme tokens need literal colors and come from theme/dataqTheme.ts, never from here.
 * Tailwind classes use the variables as arbitrary values (`bg-[var(--dq-brand)]`).
 */
export const ACCENT = "var(--dq-brand)"
export const ACCENT_SOFT = "var(--dq-brand-soft)"
